<template>
  <div class="more">
    <van-cell class="f-15" :title="en_month+ '-' +month+'月'" :value="' · '+total+'条话题'">
    </van-cell>
    <div class="topic">
      <van-list
      v-model="loading"
      :finished="finished"
      finished-text="已加载全部"
      @load="onLoad"
      >
      <div slot="loading" class="list-loading">
        <img :src="img.loading" />
      </div>
      <div v-for="item in list" :key="'list_' + item.id">
        <router-link :to="{name:'LexusTopicInfo',params:{id:item.id}}">
          <img class="topicpic" v-lazy="item.pic_url">
          <div class="picount">
            <div class="f-12">话题</div>
            <van-divider />
            <div class="f-16 mt-10">{{item.name}}</div>
            <div class="f-12 mt-10">{{item.join_num}}人参与，{{item.recom_num}}条内容值得看</div>
          </div>
        </router-link>
      </div>
    </van-list>
  </div>
</div>
</template>
<script>
  import follow from '../../../api/content';
  import common from '../../../api/common';
  import { mapState } from 'vuex';
  import { List, Cell, CellGroup,Divider } from "vant";
  export default {
    data () {
      return {
       loading: false,
       finished: false,
       list: [],
       total: 0,
       params: {
        ym:'',
        is_home:1,
        page: 1,
        size: 10
      },
      img:{
        pic:require('../../../assets/img/lexus/1.png'),
      }
    }
  },
  computed: {
    ...mapState({
      user: state => state.param.user,
      source: state => state.param.source
    })
  },
  created () {
    this.$store.commit('param/show', false)
    this.$appService.isShowReturn({state: true})
    this.$appService.isTabbar({state: true})
    this.en_month = this.$route.params.en_month
    this.month = this.$route.params.month
    var yeard= this.$route.params.yeard
    console.log(yeard+'-'+this.month)
    this.params.ym=yeard+'-'+this.month
    var params={
      event_code: '更多话题',
      event_id: '',
      title: '',
      value: '',
      path: '/Lexus/Bbs/TopicMore.vue',
      user_id: this.user ? this.user.id : 0,
      source: this.source
    }
    common.BurialPoint(params).then(res => {
      if(res.data.state==1){
      }
    })
    var apppar={
      title:this.$route.meta.title
    }
    this.$appService.changeTitle(apppar)
  },  
  methods: {
    onLoad() {
      setTimeout(() => {
        follow.getTopicList(this.params).then(res => {
          this.list.push.apply(this.list, res.data.data.data)
          this.params.page += 1
          this.loading = false
          this.total=res.data.data.total
          if(res.data.data.data.length == 0) {
            this.finished = true
          }
        })
      }, 500);
    },
  },
  components:{
    [List.name]: List,
    [Cell.name]:Cell,
    [CellGroup.name]:CellGroup,
    [Divider.name]:Divider
  }
}
</script>
<style lang="scss">
  .more{
    .van-cell{
      position: fixed;
      top: 0;
      .van-cell__title{
        font-weight: bold;
      }
      .van-cell__value{
        font-size: 12px;
      }
    }
    .topic{
      margin-top: 45px;
      .topicpic{
       width: 100%;
       height: 230px;
       object-fit: cover;
     }
     .picount{
      color: #fff;
      margin-top: -35%;
      padding: 10px;
      .mt-10{
        margin-top: 10px;
      }
      .van-divider{
        width: 20%;
      }
    }
  }
}
</style>
